/** @description always include jQuery in this manner in every file where jQuery is used */
jQuery.noConflict();


'use strict';
const AutocompleteCity = {

	init: function() {
		this.initAutocomplete();
	},

	initAutocomplete(){
		const city1Field = document.querySelector('.city-1');
		const city2Field = document.querySelector('.city-2');

		// eslint-disable-next-line no-undef,no-new
		// new google.maps.places.Autocomplete(city1Field, {
		// 	// componentRestrictions: {country: ['us', 'ca']},
		// 	fields: ['address_components', 'geometry'],
		// 	types: ['address'],
		// });
		if(city1Field) {
			city1Field.focus();
		}

		// eslint-disable-next-line no-undef,no-new
		// new google.maps.places.Autocomplete(city2Field, {
		// 	// componentRestrictions: {country: ['us', 'ca']},
		// 	fields: ['address_components', 'geometry'],
		// 	types: ['address'],
		// });
		if(city2Field) {
			city2Field.focus();
		}
	},
};

export default AutocompleteCity;
